module.exports = __webpack_public_path__ + "static/media/love-white-border.88dbfc47.svg";